/**
 * Format updated DPA Locale in dpaTransactionOptions as per expected format ex: "en_US"
 * @param {string} updatedLocale
 * @returns {string} formated DPA locale
 */

const formatUpdatedLocale = updatedLocale => updatedLocale.split('-').join('_');

export default formatUpdatedLocale;
